
import React from "react";
import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  delay?: number;
}

export const FeatureCard = ({
  icon: Icon,
  title,
  description,
  delay = 0
}: FeatureCardProps) => (
  <motion.div
    initial={{
      opacity: 0,
      y: 20
    }}
    whileInView={{
      opacity: 1,
      y: 0
    }}
    transition={{
      delay,
      duration: 0.5
    }}
    viewport={{
      once: true
    }}
    className="flex items-start gap-4 p-3 rounded-lg hover:bg-gray-50 transition-colors text-left"
  >
    <div className="bg-heaven-gold/5 p-2 rounded-full text-heaven-gold flex-shrink-0">
      <Icon className="h-6 w-6" />
    </div>
    <div className="flex-1">
      <h4 className="font-medium text-gray-900 mb-1">{title}</h4>
      <p className="text-gray-600 text-sm">{description}</p>
    </div>
  </motion.div>
);
